import ajax from './ajax'

const prefix = 'api/v1'

// 意见反馈接口
export const setadvice = ({label, content, mobile}) => {
  return ajax.post(`${prefix}/feedback?label=${label}&content=${content}&mobile=${mobile}`, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 微信登录获取token
export const getToken = ({code}) => {
  return ajax.post(`${prefix}/member/token?code=${code}`, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 发送手机验证码
export const getYzm = ({mobile}) => {
  return ajax.post(`${prefix}/verification_code?mobile=${mobile}`, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 绑定手机号
export const bindMobile = ({mobile, verificationCode}) => {
  return ajax.put(`${prefix}/member/current/mobile?mobile=${mobile}&verificationCode=${verificationCode}`, {mobile, verificationCode}, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 获取用户基本信息
export const getUserInfo = () => {
  return ajax.get(`${prefix}/member/current`)
}

// 获取默认机器人头像
export const getStaticPhoto = () => {
  return ajax.get(`${prefix}/resources/robot-icon`)
}

// 获取通告
export const getNotices = () => {
  return ajax.get(`${prefix}/notices`)
}

// 获取订单状态
export const getOrderState = ({orderId}) => {
  return ajax.get(`${prefix}/order/${orderId}/state`)
}



// WEBPACK FOOTER //
// ./src/api/user.js